// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"a43c1386","521":"a43c1386","703":"a43c1386","736":"a43c1386"}[chunkId] + ".chunk.css";
};